<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <el-alert
        :closable="false"
        title="温馨提示：订单资金尚未提现完成不可申请开票。若是平台开票，申请开票时间截止为每月1-30日，从每月31日开始到月底都不能再申请开票；服务付费支付成功后，发票将在每月30日后开具以及寄送。"
        type="warning" />
    </qx-search-box>
    <TableBox ref="tableBox" @query="query" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        billStateOptions: [], // 状态
        vehicleClassOptions: [], // 车辆种类
        form: [
          { // 收款账户名
            label: '收款账户名',
            value: 'receiveAcctName',
            type: 'input',
            placeholder: '请输入收款账户名',
          },
          { // 付款账户名
            label: '付款账户名',
            value: 'payAcctName',
            type: 'input',
            placeholder: '请输入付款账户名',
          },
          { // 状态
            label: '状态',
            value: 'billState',
            type: 'select',
            default: -1,
            placeholder: '请选择状态',
          },
          {
            label: '发车时间',
            value: 'dateTime',
            type: 'date',
            attr: {
              type: 'daterange',
            },
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 开票方
            label: '开票方',
            value: 'openBillUser',
            type: 'input',
            placeholder: '请输入开票方',
          },
          { // 申请号码
            label: '申请号码',
            value: 'applyNum',
            type: 'input',
            placeholder: '请输入申请号码',
          },
          { // 车辆种类
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择车辆种类',
          },
        ],
      },
    };
  },
  methods: {
    query (fn) {
      const res = this.$refs.searchBox.sub();
      this.$refs.tableBox[fn](res);
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.dateTime && searchBoxData.dateTime[0]) {
        searchBoxData.dateTimeStart = this.formatDate(searchBoxData.dateTime[0], 1);
        searchBoxData.dateTimeEnd = this.formatDate(searchBoxData.dateTime[1], 1);
      }
      delete searchBoxData.dateTime;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'BILL_STATE,VEHICLE_CLASS',
    });
    this.searchBoxData.billStateOptions = [ // 状态
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.vehicleClassOptions = [ // 车辆种类
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
